import React from 'react';
import Table from '../components/Table';

  export default function ContactsIndexPage({ data }) {
    const columns = React.useMemo(
      () => [
        {
          accessorFn: (row) => row.id.toString() || '',
          header: 'ID',
        },
                {
          accessorFn: (row) => row.customer?.id || '',
          header: 'Dealership ID',
        },
        {
          accessorFn: (row) => row.customer?.name || '',
          header: 'Dealership Name',
        },
        {
          accessorKey: 'title',
          header: 'Title',
        },
        {
          accessorKey: 'first_name',
          header: 'First Name',
        },
        {
          accessorKey: 'last_name',
          header: 'Last Name',
        },
        {
          accessorKey: 'email',
          header: 'Email',
        },
        {
          accessorKey: 'phone_number',
          header: 'Phone',
        },
      ],
    [],
  )

  return (
    <div>
      <h1>Contacts Index Page</h1>
      <Table columns={columns} data={data} />
    </div>

  );
}